import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { DadosCancelarOrcamento, ItemPedido, ItensACancelar, NecessitaAutorizacaoExclusaoFinanceiro, PedidoCancelamento } from "app/types/pesquisa-orcamento/CancelarOrcamento";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useMemo, useCallback, useRef, useState } from "react"
import { CancelarOrcamento } from "./CancelarOrcamento";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { PesquisarClienteContainer } from "app/components/pesquisa-cliente/PesquisarClienteContainer";
import { ModalImprimirContainer } from "app/components/itens-orcamento/orcamento-concluido/modal-imprimir/modalImprimirContainer";
import { FiltrosListarTemplateSeguranca, PermissoesImpressao } from "app/types/modalImprimir/RespostaModalImprimir";
import { Parametro } from "app/types/Parametro";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { ModalConfirmarCreditoCancelamento } from "./ModalConfirmarCreditoCancelamento/ModalConfirmarCreditoCancelamento";
import { useAppSelector } from "app/redux/hooks";

export type CancelarOrcamentoContainerProps = {
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
    pedido?: Partial<PedidoCancelamento>
}

const PERMISSOES_MODAL_IMPRIMIR: PermissoesImpressao = {
    permitidoEnviarEmail: false,
    permitidoImprimirWord: false,
    permitidoAlterarCopiaEmail: false,
    permitidoAlterarCopiaOcultaEmail: false,
    permitidoAlterarAssuntoEmail: false,
    permitidoAlterarMensagemEmail: false,
    permitidoAnexarEmail: false
}

export const CancelarOrcamentoContainer = (props: CancelarOrcamentoContainerProps) => {

    const [inicializando, setInicializando] = useState<boolean>(true) // 436456
    const [processandoSalvar, setProcessandoSalvar] = useState<boolean>(false) // 436456
    const [dadosCancelamento, setDadosCancelamento] = useState<Partial<DadosCancelarOrcamento>>({})
    const [itensSelecionados, setItensSelecionados] = useState<ItemPedido[]>([])
    const [itemACancelar, setItemACancelar] = useState<Partial<PedidoCancelamento>>(props.pedido ?? null)
    const [permitidoImprimirComprovanteCredito, setPermitidoImprimirComprovanteCredito] = useState<boolean>(false)
    const [permitidoImprimirReciboBaixaCancelamento, setPermitidoImprimirReciboBaixaCancelamento] = useState<boolean>(false) // 476757
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [oidUsuarioLogado, setOidUsuarioLogado] = useState<number>(0)
    const [mostrarModalImprimir, setMostrarModalImprimir] = useState<boolean>(false);
    const [mostrarModalCredito, setMostrarModalCredito] = useState<boolean>(false);
    const [urlBaseImpressao, setUrlBaseImpressao] = useState<string>("");
    const [autorizado, setAutorizado] = useState<boolean>(false);
    const [mostrarAutorizacao, setMostrarAutorizacao] = useState<Partial<NecessitaAutorizacaoExclusaoFinanceiro>>();
    const [idPedidoCancelado, setIdPedidoCancelado] = useState(0)
    //const processandoCancelamento = useRef(false)
    const [pesquisandoCliente, setPesquisandoCliente] = useState<boolean>(false) //444803
    const [filtroTemplateImpressao, setFiltroTemplateImpressao] = useState<FiltrosListarTemplateSeguranca>(null) //476757
    const [oidNotaCreditoGerada, setOidNotaCreditoGerada] = useState<number>(0) //476757
   

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])

    // Refs para leitura no momento da execução sem invalidar useCallbacks
    const itensSelecionadosRef = useRef(itensSelecionados)
    itensSelecionadosRef.current = itensSelecionados
    const autorizadoRef = useRef(autorizado)
    autorizadoRef.current = autorizado

    const token: string = globalMU.token();
    const orcamento = useAppSelector((store) => store.orcamento);

    const onObterDadosCancelarOrcamento = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.ObterDadosCancelarOrcamento(props.orcamentoSelecionado.NumeroPedido, props.orcamentoSelecionado.TipoOrcamento);
            if (!isMounted.current) return;
            if (!resultado || "HasErrors" in resultado) {
                onVoltar();
                return;
            }

            setDadosCancelamento(resultado);
            setItemACancelar(resultado.Pedido);
            // 444713 - onSelecionaTodosItens(resultado.Pedido);
            if (resultado?.Pedido?.OrcamentoUnificado)
            {
                setItensSelecionados(resultado?.Pedido?.Itens) // 462346
            }

            

        } catch (e) {
            if (!isMounted.current) return;
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "IMPRIMIR_COMPROVANTE_CREDITO_CANCELAMENTO_ORCAMENTO",
                    "PERMITIR_EXCLUIR_FINANCEIRO_CANCELAMENTO_PEDIDO_POSTERIOR_DATA_VENDA",
                    "GERAR_NOTA_CREDITO_CANCELAMENTO_PEDIDO"
                ],
            })
        );
    };

    const obterOidUsuario = async () => {
        try {
            globalMU.blockUI()
            const oid = await microuniversoApi.Usuario.obterOid();
            if (!isMounted.current) return;
            setOidUsuarioLogado(oid);
        }
        catch (erro) {
            if (!isMounted.current) return;
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }

    const onExcluirControleDeExclusividade = useCallback(async () => {
        try {
            globalMU.blockUI()
            await microuniversoApi.Comum.excluirControleDeExclusividade(props.orcamentoSelecionado.NumeroPedido.toString(), "PEDICLICAD");
        }
        catch (erro) {
            tratamentoErroPadrao(erro);
        }
        finally {
            globalMU.unblockUI()
        }
    }, [props.orcamentoSelecionado.NumeroPedido])

    const onRenderizarCancelarOrcamento = () => {
        renderizarComponentReact(<CancelarOrcamentoContainer {...props} />, "pesquisar-pedidos-region", true)
    }

    const onPesquisarCliente = useCallback(() => {
        setPesquisandoCliente(true) // 444803
    }, [])

    const onLimparCliente = useCallback(() => {
        setItemACancelar(prev => ({ ...prev, CodigoCliente: 7, NomeCliente: "CONSUMIDOR FINAL" }))
    }, []) // usa functional update — sem dep em itemACancelar

    const onSelecionarClienteCallback = useCallback((cliente) => {
        setItemACancelar(prev => ({ ...prev, CodigoCliente: cliente.Codigo, NomeCliente: cliente.Nome }))
        setPesquisandoCliente(false)
    }, []) // usa functional update — sem dep em itemACancelar

    const onSelecionarItem = useCallback((item: ItemPedido) => {
        if (processandoSalvar) return // 436456
        if (item.MensagemErro != null && item.MensagemErro != "") {
            globalMU.showWarnMessage(item.MensagemErro)
            return
        }
        setItensSelecionados(prev =>
            prev.some(p => p.Codigo == item.Codigo)
                ? prev.filter(v => v.Codigo != item.Codigo)
                : prev.concat(item)
        )
    }, [processandoSalvar])

    const onSelecionaTodosItens = useCallback((pedido?: Partial<PedidoCancelamento>) => {
        const itens = itemACancelar == null ? pedido : itemACancelar;

        if (itens?.OrcamentoUnificado) {
            return;
        }

        const todosSelecionados = itens?.Itens?.every((i) => i.MensagemErro === "" && itensSelecionadosRef.current.some((item) => item.Codigo === i.Codigo));

        if (!todosSelecionados) {
            itens?.Itens?.forEach((i) => {
                if (i.MensagemErro === "" && !itensSelecionadosRef.current.some((item) => item.Codigo === i.Codigo)) {
                    setItensSelecionados((prevItens) => [...prevItens, i]);
                }
            });
        } else {
            setItensSelecionados([]);
        }
    }, [itemACancelar])

    const onLiberarPendencia = useCallback(async (numeroPedido, senha: string) => {
        try {
            setProcessandoSalvar(false) // 436456
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.LiberarAutorizacaoPendenciaCancelarOrcamento(numeroPedido, senha)
            if (!isMounted.current) return;
            if (resultado === true) {
                setAutorizado(true)
                setMostrarAutorizacao({})
                globalMU.showSuccessMessage("Autorizado com sucesso")
            }
        } catch (e) {
            if (!isMounted.current) return;
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }, []) // setState são estáveis; isMounted é ref


    // Ref para proxy estável de onCancelarOrcamento (atualizado a cada render)
    const onCancelarOrcamentoRef = useRef<(pedido: Partial<PedidoCancelamento>) => void>(null)

    const onVerificarAutorizacaoCancelarOrcamento = useCallback(async (pedido: Partial<PedidoCancelamento>, valorNotaCreditoGerar?: number) => {
        try {
            setProcessandoSalvar(true) // 436456
            globalMU.blockUI();
            if (itensSelecionadosRef.current.length == 0) {
                globalMU.showErrorMessage("Não foi marcado nenhum produto!");
                setProcessandoSalvar(false) // 436456
                return
            }
            setProcessandoSalvar(true) // 436456
            const pedidoAlterado = {
                ...pedido,
                ValorFrete: null,
                ValorNotaCreditoGerar: valorNotaCreditoGerar,
                Itens: pedido.Itens.filter(p => itensSelecionadosRef.current.some(i => i.Codigo == p.Codigo)),
                DataCancelamento: pedido.DataVenda,
            };

            if (autorizadoRef.current) {
                globalMU.blockUI();
                setProcessandoSalvar(true) // 436456
                onCancelarOrcamentoRef.current(pedidoAlterado)
                return
            }
            setProcessandoSalvar(true) // 436456
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.VerificarAutorizacaoCancelarOrcamento(
                pedido.Numero, pedidoAlterado
            );
            if (!isMounted.current) return;
            globalMU.blockUI();
            setProcessandoSalvar(true) // 436456
            resultado.NecessitaAutorizacao ? setMostrarAutorizacao(resultado) : onCancelarOrcamentoRef.current(pedidoAlterado)

        } catch (e) {
            if (!isMounted.current) return;
            tratamentoErroPadrao(e);
            setProcessandoSalvar(false)
        } finally {
            globalMU.unblockUI();
        }
    }, []) // lê itensSelecionados e autorizado via refs; onCancelarOrcamento via ref


    const onCancelarOrcamento = async (pedido: Partial<PedidoCancelamento>) => {
        try {
            setProcessandoSalvar(true) // 436456
            globalMU.blockUI();

            if (!mostrarModalCredito && dadosCancelamento?.GerarNotaCreditoCancelamento && dadosCancelamento?.PermitirAlterarValorCreditoCancelamento &&
                !globalMU.isNullOrEmptyOrZero(pedido?.ValorNotaCreditoSobreFreteDespesas + pedido?.ValorNotaCreditoSobreProdutos)) {

                setItemACancelar(pedido);
                setMostrarModalCredito(true);
                return
            }
            setProcessandoSalvar(true) // 436456
            globalMU.blockUI();
            const resultado = await microuniversoApi.Orcamento.CancelarOrcamento(
                pedido.Numero, pedido, dadosCancelamento?.NecessitaSelecionarCliente ? pedido.CodigoCliente : null,
            );
            if (!isMounted.current) return;
            globalMU.blockUI();
            setProcessandoSalvar(true) // 436456
            if (!resultado || "HasErrors" in resultado) {
                setProcessandoSalvar(false) // 436456
                return;
            }

            if (resultado && resultado.Mensagem && typeof (resultado.Mensagem) == "string" && resultado.Mensagem != "") {
                globalMU.showSuccessMessage(resultado.Mensagem);
                try {
                    onExcluirControleDeExclusividade() // 474579
                } catch { 
                    //nao faz nada
                }
                setProcessandoSalvar(false) // 436456
            }
            setProcessandoSalvar(true) // 436456
            if ((resultado.ImprimeComprovanteCredito || resultado.ImprimeComprovanteBaixaCancelamento) && resultado.IdPedidoCancelado > 0) {
                 try {
                    onExcluirControleDeExclusividade() // 474579
                } catch { 
                    //nao faz nada
                }
                setOidNotaCreditoGerada(resultado.OidNotaCreditoGerada ?? 0) // 476757
                resultado.ImprimeComprovanteCredito 
                               && valorParametro("IMPRIMIR_COMPROVANTE_CREDITO_CANCELAMENTO_ORCAMENTO") == "S" 
                               && setPermitidoImprimirComprovanteCredito(true)
                resultado.ImprimeComprovanteBaixaCancelamento // 476757
                               && setPermitidoImprimirReciboBaixaCancelamento(true) // 476757
                setIdPedidoCancelado(resultado.IdPedidoCancelado)
            } else {
                onVoltar()
            }

        } catch (e) {
            if (!isMounted.current) return;
            setProcessandoSalvar(false) // 436456
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }
    // Atualiza o proxy a cada render para que onVerificarAutorizacaoCancelarOrcamento
    // (useCallback estável) sempre chame a versão mais recente de onCancelarOrcamento
    onCancelarOrcamentoRef.current = onCancelarOrcamento

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
        passo == "Pesquisa de Orçamento" && itemACancelar != null && onExcluirControleDeExclusividade();
    }

    const onVoltar = () => {
        setProcessandoSalvar(true) // 436456
        props.onRemover()
        props.onVoltar()
        itemACancelar != null && onExcluirControleDeExclusividade();
    }

    useEffect(() => {
        passosInterno.current.set("Cancelar Orçamento", () => { })
        const executarFuncoes = async () => {
            await Promise.all([
                onObterDadosCancelarOrcamento(),
                obterOidUsuario(),
                atualizarParametros(),
            ])
        }
    
        executarFuncoes()
    }, [])

    useEffect(() => {
        $.connection.hub.disconnected(function () {
            //onVoltar()
        });
    }, [])

    useEffect(() => {
        if (inicializando && dadosCancelamento != null && parametros != null
                    && oidUsuarioLogado != null && oidUsuarioLogado > 0
                    && dadosCancelamento?.Pedido?.Numero != null && dadosCancelamento?.Pedido?.Numero > 0 )
        {
            if (dadosCancelamento?.Pedido?.Situacao == "3")
            {
                globalMU.showInfoMessage("Pedido já cancelado!")
            }
            else if (dadosCancelamento?.Pedido?.Itens?.some((i) => i.MensagemErro === ""))
            {
                globalMU.showInfoMessage("Selecione os registros para cancelar!")
            }
            else
            {
                globalMU.showInfoMessage("Não existe nenhum registro para ser cancelado!")
            }

            if (dadosCancelamento?.NecessitaSelecionarCliente) { // 484994
                globalMU.showInfoMessage("É necessário selecionar um cliente para realizar o cancelamento!")
            }

            setInicializando(false)
        }
    }, [dadosCancelamento, parametros, oidUsuarioLogado, dadosCancelamento?.Pedido?.Numero])

    const filtrosTemplatesComprovanteCreditoCancelamento = useMemo<FiltrosListarTemplateSeguranca>(() => ({
        token: encodeURIComponent(token),
        codigoUsuario: oidUsuarioLogado,
        siglaFuncionalidade: "PESQUISAR_ORCAMENTO",
        siglaAcao: "IMPRIMIR_COMPROVANTE_CANCELAMENTO",
        codigoFilial: dadosCancelamento?.Pedido?.Filial ?? "null", // 455683
    }), [token, oidUsuarioLogado, dadosCancelamento?.Pedido?.Filial]);

    const filtrosTemplatesReciboBaixaCancelamento = useMemo<FiltrosListarTemplateSeguranca>(() => ({
        token: encodeURIComponent(token),
        codigoUsuario: oidUsuarioLogado,
        siglaFuncionalidade: "PESQUISAR_ORCAMENTO",
        siglaAcao: "IMPRIMIR_RECIBO_BAIXA_CANCELAMENTO",
        codigoFilial: dadosCancelamento?.Pedido?.Filial ?? "null", // 455683
    }), [token, oidUsuarioLogado, dadosCancelamento?.Pedido?.Filial]);

    const handleErrorValidacao = useCallback((erroFormulario) => {
        globalMU.showErrorMessage(erroFormulario)
    }, [])

    const onOpenModalImpressao = useCallback((tipo: 'ComprovanteCreditoCancelamento' | 'ReciboBaixaCancelamento') => { // 476757
        if (tipo === 'ComprovanteCreditoCancelamento') {
            setFiltroTemplateImpressao(filtrosTemplatesComprovanteCreditoCancelamento);
            setUrlBaseImpressao("/Relatorio/ComprovanteCreditoCancelamento");
        } else if (tipo === 'ReciboBaixaCancelamento') {
            setFiltroTemplateImpressao(filtrosTemplatesReciboBaixaCancelamento);
            setUrlBaseImpressao("/Relatorio/ReciboBaixaCancelamento"); // 476757
        }
        setMostrarModalImprimir(true)
    }, [filtrosTemplatesComprovanteCreditoCancelamento, filtrosTemplatesReciboBaixaCancelamento])

    const mostrarDataCancelamento = useMemo(() =>
        valorParametro("PERMITIR_EXCLUIR_FINANCEIRO_CANCELAMENTO_PEDIDO_POSTERIOR_DATA_VENDA") == "S" &&
        valorParametro("GERAR_NOTA_CREDITO_CANCELAMENTO_PEDIDO") != "S"
    , [parametros]) // valorParametro lê parametros

    const parametrosTemplateCancelamento = useMemo(() => [
        {
            nome: "idPedidoCancelado",
            valor: [idPedidoCancelado],
        },
        {
            nome: "numeroVia",
            valor: [itemACancelar?.Numero],
        },
        {
            nome: "oidNotaCreditoGerada", // 476757
            valor: [oidNotaCreditoGerada],
        }
    ], [idPedidoCancelado, itemACancelar?.Numero, oidNotaCreditoGerada])

    const onCloseModalImprimir = useCallback(() => {
        setMostrarModalImprimir(false)
    }, [])

    const creditoCancelamento = useMemo(() => ({
        ValorNotaCreditoSobreFreteDespesas: itemACancelar?.ValorNotaCreditoSobreFreteDespesas,
        ValorNotaCreditoSobreFreteDespesasAlterado: itemACancelar?.ValorNotaCreditoSobreFreteDespesas,
        ValorNotaCreditoSobreProdutos: itemACancelar?.ValorNotaCreditoSobreProdutos,
        ValorNotaCreditoSobreProdutosAlterado: itemACancelar?.ValorNotaCreditoSobreProdutos,
    }), [itemACancelar?.ValorNotaCreditoSobreFreteDespesas, itemACancelar?.ValorNotaCreditoSobreProdutos])

    const onCancelarModalCredito = useCallback(() => {
        setMostrarModalCredito(false)
    }, [])

    const onConfirmarModalCredito = useCallback((valorNotaCreditoGerar: number) => {
        onVerificarAutorizacaoCancelarOrcamento(itemACancelar, valorNotaCreditoGerar)
    }, [onVerificarAutorizacaoCancelarOrcamento, itemACancelar])

    const onVoltarPesquisarCliente = useCallback(() => {
        setPesquisandoCliente(false)
    }, [])

    return (<>
        {inicializando || pesquisandoCliente ? null :
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="CancelarOrcamentoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <CancelarOrcamento
                mostrarDataCancelamento={mostrarDataCancelamento}
                itemACancelar={itemACancelar}
                dadosCancelarOrcamento={dadosCancelamento}
                itemSelecionados={itensSelecionados}
                processandoCancelamento={processandoSalvar}
                jaCancelado={dadosCancelamento?.Pedido?.Situacao == "3"}
                inicializando={inicializando}
                permitidoImprimirComprovanteCredito={permitidoImprimirComprovanteCredito}
                permitidoImprimirReciboBaixaCancelamento={permitidoImprimirReciboBaixaCancelamento}
                mostrarAutorizacao={mostrarAutorizacao}
                corSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                onVerificarAutorizacaoCancelarOrcamento={onVerificarAutorizacaoCancelarOrcamento}
                onSelecionaTodosItens={onSelecionaTodosItens}
                onLimparCliente={onLimparCliente}
                onPesquisarCliente={onPesquisarCliente}
                onSelecionarItem={onSelecionarItem}
                onErrorValidacao={handleErrorValidacao}
                openModalImpressao={onOpenModalImpressao}
                onLiberarPendencia={onLiberarPendencia}
            />

            { mostrarModalImprimir && urlBaseImpressao != "" && // 476757
            <ModalImprimirContainer
                filtrosTemplates={filtroTemplateImpressao}
                urlBase={urlBaseImpressao}
                parametrosTemplate={parametrosTemplateCancelamento}
                exibirModalImprimir={mostrarModalImprimir}
                onClose={onCloseModalImprimir}
                permissaoSenhaModalImprimir={undefined} // 450413
                permissoes={PERMISSOES_MODAL_IMPRIMIR}
            />
            }

            {mostrarModalCredito &&
            <ModalConfirmarCreditoCancelamento
                creditoCancelamento={creditoCancelamento}
                onCancelar={onCancelarModalCredito}
                onConfirmar={onConfirmarModalCredito}
                onErrorValidacao={handleErrorValidacao}
                onFecharModal={onCancelarModalCredito}
                open={mostrarModalCredito}
                percentualMaximoAlteracao={Number(dadosCancelamento?.PercentualMaximoAlteracaoCredito)}
            />
        }
        </>
       }

        { pesquisandoCliente && // 444803
            <PesquisarClienteContainer
                regiaoRenderizada="pesquisar-pedidos-region" passos={passosInterno.current}
                foraOrcamento={true}
                /*
                onVoltar={onRenderizarCancelarOrcamento}
                */
               onVoltar={onVoltarPesquisarCliente}
                consultar
                /*
                onSelecionarClienteCallback={(cliente) => {
                    renderizarComponentReact(<CancelarOrcamentoContainer {...props}
                        pedido={{ ...item, CodigoCliente: cliente.Codigo, NomeCliente: cliente.Nome }} />, "pesquisar-pedidos-region", true)
                }}
                */
                onSelecionarClienteCallback={onSelecionarClienteCallback}
            />
         }
            </>
    )
}
